
import { OLMSApiService } from '@/shared/apis'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

type ProcessDropOnInboxPayload = {
  orderIds: EntityId[]
  scenarioId: EntityId
}

export const processDropOnInbox = createAsyncThunk<void, ProcessDropOnInboxPayload, { state: RootState }>(
  'dragdrop/processDropOnInbox',
  async ({ orderIds, scenarioId }, { getState }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen
    const endpoint = currentScreen === 'planning' ? '/planning/dissociate' : '/runsheet/dissociate'

    await OLMSApiService.post<null>(endpoint, {
      orderIds: orderIds,
      scenarioId: scenarioId,
    })
  },
)
